module.exports = __webpack_public_path__ + "media/images/icon_message01_18-14-5228ab27439d3624e17c5566df921ca0.png";